import React from 'react';
import PropTypes from 'prop-types';
import DateTimeField from 'components/show/DateTimeField';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import utils from 'helpers/utils';

const ProductReservationsOthersList = (props) => {
    const {
        link,
        reservations,
        resource,
    } = props;

    if (utils.isEmpty(reservations)) {
        return <NoResults label={ `resources.products.occupancy.reservations.id.no_results` } />;
    }

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        resource={ resource }
                        source='full_name'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        resource={ resource }
                        source='license_plate'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        resource={ resource }
                        source='destination_arrival_date'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        resource={ resource }
                        source='destination_departure_date'
                    />
                </HeaderColumn>
            </TableRow>

            {
                utils.map(reservations, (reservation) => {
                    const {
                        id,
                        reservation_data,
                    } = reservation;

                    const {
                        destination_arrival_date,
                        destination_departure_date,
                        first_name,
                        last_name,
                        license_plate,
                    } = reservation_data;

                    return (
                        <TableRow key={ `reservation-${ id }` }>
                            <TableBodyCell
                                field={ <TextField value={ utils.fullName(first_name, last_name) } /> }
                                link={ link }
                                record={ reservation }
                                resource={ resource }
                                source='full_name'
                            />
                            <TableBodyCell
                                field={ <TextField value={ license_plate || '' } /> }
                                link={ link }
                                record={ reservation }
                                resource={ resource }
                                source='license_plate'
                            />
                            <TableBodyCell
                                field={ <DateTimeField value={ destination_arrival_date } /> }
                                link={ link }
                                record={ reservation }
                                resource={ resource }
                                source='destination_arrival_date'
                            />
                            <TableBodyCell
                                field={ <DateTimeField value={ destination_departure_date } /> }
                                link={ link }
                                record={ reservation }
                                resource={ resource }
                                source='destination_departure_date'
                            />
                        </TableRow>
                    );
                })
            }
        </Table>
    );
};

ProductReservationsOthersList.defaultProps = {
    link: 'show',
    resource: 'reservations',
};

ProductReservationsOthersList.propTypes = {
    link: PropTypes.string,
    reservations: PropTypes.arrayOf(PropTypes.object).isRequired,
    resource: PropTypes.string,
};

export default ProductReservationsOthersList;


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/reservations/list/ProductReservationsOthersList.js